import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import { en } from "~/locales/en";

export const resources = {
  en: {
    translation: en,
  },
} as const;

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export { i18n };
